<template>
  <div>
    <!-- <CCard class="content-fade-in mt-3p5">

    </CCard> -->
    <CCard class="content-fade-in mt-3p5">
      <CCardHeader>
        <h6>Thông tin lịch phát</h6>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol xs="12" sm="6" md="6" xl="6">
            <BaseInput :options="scheduleData.dateRangeInput.options" :data="scheduleData.dateRangeInput.data"/>
          </CCol>
          <CCol xs="12" sm="6" md="6" xl="6">
            <div class="form-group">
              <label style="display: inline-flex;">Thiết bị
                <span class="required">*</span>
                <CInputCheckbox custom :checked="isSelectedAllDevices" class="ml-2"
                                @update:checked="changeSelectedAllDevice($event)"
                                addInputClasses="override-custom"></CInputCheckbox>
                Chọn tất cả
              </label>

              <multiselect
                id="deviceSelect"
                v-model="scheduleData.deviceInput.data.model"
                placeholder="Chọn thiết bị"
                label="text"
                track-by="value"
                :options="scheduleData.deviceInput.options"
                selectLabel="Chọn"
                deselectLabel="Bỏ chọn"
                selectedLabel="Đã chọn"
                :close-on-select="false"
                :class="!(scheduleData.deviceInput.data.validator && scheduleData.deviceInput.data.validator.isValid == true) ? 'input-error' : ''"
                :multiple="true">
                <span slot="noResult">Không có dữ liệu tương ứng!</span>
                <span slot="noOptions">Danh sách rỗng!</span>
              </multiselect>

              <div class="valid-error"
                   v-show="!(scheduleData.deviceInput.data.validator ?scheduleData. deviceInput.data.validator.isValid : true)">
                {{
                  scheduleData.deviceInput.data.validator
                    ? scheduleData.deviceInput.data.validator.errorMessage
                    : ""
                }}
              </div>
            </div>
          </CCol>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div style="margin-top: 10px">
                <CButton
                  style="float: right; margin-left: 5px"
                  color="primary"
                  v-c-tooltip.hover="'Lưu lại'"
                  class="btn-action-primary"
                  @click="submitUpdateSchedule()">
                  <i class="fa fa-save"></i> Lưu lại
                </CButton>
                <CButton
                  style="float: right; margin-left: 5px"
                  color="secondary"
                  v-c-tooltip.hover="'Quay lại'"
                  class="btn-action-primary"
                  @click="$router.go(-1)">
                  <i class="fa fa-reply"></i> Quay lại
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
      <CCardHeader>
        <h6>Thông tin chi tiết lịch phát</h6>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
            <label>Thao tác</label>
            <div class="dropdown btn-group" style="height: 36px;">
              <button class="btn">
                <div class="group-checkbox">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      v-model="actionData.model.selectedAll"
                      @change="changeSelectAll"
                      id="selectedAll"
                    />
                    <label class="custom-control-label" for="selectedAll"></label>
                  </div>
                </div>
              </button>
              <button
                type="button"
                class="dropdown-toggle dropdown-toggle-split btn"
                data-toggle="dropdown"
                aria-expanded="false"
                aria-haspopup="true"
              ></button>
              <div class="dropdown-menu">
                <button
                  :disabled="actionData.model.listScheduleDetailSelectedId.length === 0"
                  class="dropdown-item"
                  @click="setupSelectOneAction('update_active_list', null, true)"
                  color="success"
                >
                  <CIcon name="cil-check" style="success" class="mr-2"/>
                  Kích hoạt tất cả
                </button>

                <button
                  :disabled="actionData.model.listScheduleDetailSelectedId.length === 0"
                  class="dropdown-item"
                  @click="setupSelectOneAction('update_active_list', null, false)"
                  color="danger"
                >
                  <CIcon name="cil-x-circle" style="danger" class="mr-2"/>
                  Hủy tất cả
                </button>
              </div>
            </div>
          </CCol>
          <CCol xs="12" sm="4" md="3" lg="3" xl="2">
            <div class="form-group">
              <label for="datepicker">Từ ngày - đến ngày</label>
              <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                          :min-date="minDate" :max-date="maxDate"
                          is-range class="datepicker">
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    :value="inputValue.start + ' - ' + inputValue.end"
                    v-on="inputEvents.start"
                    class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                    readonly
                  />
                </template>
              </DatePicker>
            </div>
          </CCol>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <div style="margin-top: 10px">
                <CButton
                  style="float: right; margin-left: 5px"
                  color="primary"
                  v-c-tooltip.hover="'Tải lại'"
                  class="btn-action-primary"
                  @click="loadDataMainTable(true)"
                >
                  <i class="fa fa-refresh"></i>&nbsp; Tải lại
                </CButton>
              </div>
            </div>
          </CCol>
        </CRow>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listScheduleDetailSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #type="{ item }">
            <td>
              <span v-if="item.type == 0" class="badge badge-secondary">Văn bản</span>
              <span v-else class="badge badge-info">Media</span>
            </td>
          </template>
          <template #playDate="{ item }">
            <td v-if="item.playDate != null">
              {{ $helper.formatDateDDMMYYYY(item.playDate) }}
            </td>
            <td v-if="item.playDate == null"></td>
          </template>
          <template #startTime="{ item }">
            <td v-if="item.startTime != null">
              <!-- {{ item.startTime[0] + ":" + item.startTime[1]}} -->
              {{ $helper.formatHHMM(item.startTime) }}
              <!-- {{item.startTime}} -->
            </td>
            <td v-if="item.startTime == null"></td>
          </template>
          <template #endTime="{ item }">
            <td v-if="item.endTime != null">
              <!-- {{ item.endTime[0] + ":" + item.endTime[1]}} -->
              {{ $helper.formatHHMM(item.endTime) }}
              <!-- {{item.endTime}} -->
            </td>
            <td v-if="item.endTime == null"></td>
          </template>
          <template #active="{item}">
            <td>
                <span v-if="item.active == 1" class="dot-custom dot-success">
                Hoạt động
              <BaseSwitch v-if="item.status === 0 || item.status === 1" class="mx-1" color="success" checked
                          variant="3d" v-c-tooltip.hover="'Hủy'"
                          v-bind="labelIcon"
                          @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.playDate, item.startTime, item.endTime)"/>
              </span>
              <span v-else class="dot-custom dot-danger">
                Đã hủy
                <BaseSwitch v-if="item.startTime >= new Date()" class="mx-1" color="danger" variant="3d"
                            v-c-tooltip.hover="'Kích hoạt'" v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_active', item.id, item.active, item.playDate, item.startTime, item.endTime)"/>
              </span>
            </td>
          </template>
          <template #status="{item}">
            <td>
              <span v-if="item.status == 0" class="badge badge-info">Chờ phát</span>
              <span v-else-if="item.status == 1" class="badge badge-warning">Đang phát</span>
              <span v-else-if="item.status == 2" class="badge badge-success">Đã phát</span>
              <span v-else-if="item.status == 3" class="badge badge-danger">Phát lỗi</span>
              <span v-else-if="item.status == 4" class="badge badge-danger">Đã hủy</span>
              <span v-else-if="item.status == 5" class="badge badge-danger">Bị trùng</span>
            </td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton v-if="item.status === 0 || item.status === 1 || item.status === 5"
                         color="info"
                         variant="outline"
                         v-c-tooltip.hover="'Cập nhật'"
                         square
                         size="sm"
                         @click="updateData(item.id, item.playDate, item.startTime, item.endTime)">
                  <CIcon name="cil-pencil"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CModal title="Cập nhật lịch phát" :show.sync="isShowModelUpdate" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" sm="12" md="12" xl="12">
          <div class="form-group">
            <label for="datepicker">Ngày phát
              <span class="required">*</span></label>
            <br/>
            <DatePicker id="playDate" v-model="dataDetail.playDate.data.model"
                        :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" class="datepicker"
                        :min-date="minDate" :max-date="maxDate">
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="inputValue"
                  v-on="inputEvents"
                  class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                  readonly
                />
              </template>
            </DatePicker>
          </div>
        </CCol>
        <CCol xs="12" sm="6" md="6" xl="6">
          <div class="form-group">
            <label for="datepicker">Phát từ giờ
              <span class="required">*</span></label>
            <br/>
            <DatePicker
              id="startTime"
              mode="time"
              v-model="dataDetail.startTime.data.model"
              :masks="{ input: 'HH:MM', data: 'HH:MM' }"
              is24hr>
            </DatePicker>
          </div>
        </CCol>
        <CCol xs="12" sm="6" md="6" xl="6">
          <div class="form-group">
            <label for="datepicker">Đến giờ
              <span class="required">*</span></label>
            <br/>
            <DatePicker
              id="endTime"
              mode="time"
              v-model="dataDetail.endTime.data.model"
              :masks="{ input: 'HH:MM', data: 'HH:MM' }"
              is24hr>
            </DatePicker>
          </div>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModelUpdate = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitUpdate()"><i class="fa fa-check"></i> Cập
          nhật
        </button>
      </template>
    </CModal>
    <CModal title="Lịch phát đã tồn tại" :show.sync="exist.isShowModelExist" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          Đã tồn tại lịch phát ngày <span style="font-weight:bold">{{ exist.playDate }}</span>
          khung giờ <span style="font-weight:bold">{{ exist.startTime + ' - ' + exist.endTime }}</span>
          với các thiết bị:
          <span v-for="i of exist.devices">
            <br/>
            {{ '- ' + i }}
          </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="exist.isShowModelExist = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="reloadPage(exist.id)"><i class="fa fa-eye"></i> Xem lịch
          đã tồn tại
        </button>
      </template>
    </CModal>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";
import Multiselect from "vue-multiselect";
import BaseSwitch from "@/views/base/BaseSwitch";
import {USER_NAME} from '../../constant';

export default {
  name: "ScheduleDetailList",
  components: {
    BaseFormLoading,
    BaseTable,
    BaseInput,
    DatePicker,
    ModalConfirm,
    Multiselect,
    BaseSwitch
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let today = new Date();
    let actionTypeMapping = new Map();

    actionTypeMapping.set("update_active_list", {
      url: "/schedule-detail/update-active-list",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.active == false ? "hủy toàn bộ lịch đã chọn" : "kích hoạt toàn bộ lịch đã chọn", 'từ ngày'
          , that.$helper.formatDateDDMMYYYY(that.actionData.model.fromDate) + ' đến ngày '
          + that.$helper.formatDateDDMMYYYY(that.actionData.model.toDate))
      },
      // isJsonContentType: false,
      dataSubmit: function () {
        return {
          scheduleId: that.actionData.model.scheduleId,
          userName: localStorage.getItem(USER_NAME),
          active: that.actionData.model.active == false ? 0 : 1,
          selectedAll: that.actionData.selectedAll ? 1 : 0,
          listScheduleDetailSelectedId: that.actionData.listScheduleDetailSelectedId
        };
      },
      successCallback: function (response) {
        if (response.data && response.data.id) {
          that.exist.id = response.data.id;
          that.exist.msg = response.data.msg;
          that.exist.startTime = response.data.startTime;
          that.exist.endTime = response.data.endTime;
          that.exist.playDate = response.data.playDate;
          that.exist.devices = response.data.devices;
          that.exist.isShowModelExist = true;
        } else {
          that.showSuccessMsg({message: that.actionData.model.active == true ? "Hủy lịch thành công" : "Kích hoạt lịch thành công"});
          that.loadDataMainTable();
        }
      },
      errorCallback: function (error) {
        console.log(error)
        that.$helper.handleError(that.$router, error);
      },
    });


    actionTypeMapping.set("update_active", {
      url: "/schedule-detail/update-active",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.active == true ? "hủy" : "kích hoạt", 'lịch ngày'
          , that.$helper.formatDateDDMMYYYY(that.actionData.model.playDate) + ' khung giờ '
          + that.$helper.formatHHMM(that.actionData.model.startTime) + '-'
          + that.$helper.formatHHMM(that.actionData.model.endTime));
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id, userName: localStorage.getItem(USER_NAME)
        };
      },
      successCallback: function (response) {
        if (response.data && response.data.id) {
          that.exist.id = response.data.id;
          that.exist.msg = response.data.msg;
          that.exist.startTime = response.data.startTime;
          that.exist.endTime = response.data.endTime;
          that.exist.playDate = response.data.playDate;
          that.exist.devices = response.data.devices;
          that.exist.isShowModelExist = true;
        } else {
          that.showSuccessMsg({message: that.actionData.model.active == true ? "Hủy lịch thành công" : "Kích hoạt lịch thành công"});
          that.loadDataMainTable();
        }
      },
      errorCallback: function (error) {
        console.log(error)
        that.$helper.handleError(that.$router, error);
      },
    });

    return {
      loading: {value: false},
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          id: null,
          active: null,
          startTime: null,
          endTime: null,
          playDate: null,
          scheduleDetailSelectedId: null,
          listScheduleDetailSelectedId: [],
          fromDate: null,
          toDate: null,
          scheduleId: null
        }
      },
      isShowModelUpdate: false,
      isSelectedAllDevices: false,
      minDate: today,
      maxDate: today,
      scheduleData: {
        dateRangeInput: {
          options: {
            label: "Từ ngày - đến ngày",
            readonly: true
          },
          data: {
            name: "dateRange",
            model: ""
          }
        },
        deviceInput: {
          options: [],
          data: {
            name: "devices",
            model: [],
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.scheduleData.deviceInput.data.model;
                if (value === "" || that.scheduleData.deviceInput.data.model.length == 0) {
                  this.isValid = false;
                  this.errorMessage = "Thiết bị không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            },
          },
        },
      },
      exist: {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false
      },
      dataDetail: {
        id: null,
        playDate: {
          options: {
            label: "Ngày phát",
            placeholder: "Ngày phát"
          },
          data: {
            name: "playDate",
            model: "",
            updateCallback: function () {
              that.submitUpdate();
            }
          }
        },
        startTime: {
          options: {
            label: "Phát từ giờ",
            placeholder: "Phát từ giờ"
          },
          data: {
            name: "startTime",
            model: "",
            updateCallback: function () {
              that.submitUpdate();
            }
          }
        },
        endTime: {
          options: {
            label: "Đến giờ",
            placeholder: "Đến giờ"
          },
          data: {
            name: "endTime",
            model: "",
            updateCallback: function () {
              that.submitUpdate();
            }
          }
        }
      },
      dateRange: {
        start: new Date().setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            {key: "index", label: "STT"},
            {key: "playDate", label: "Ngày phát"},
            {key: "startTime", label: "Phát từ giờ"},
            {key: "endTime", label: "Đến giờ"},
            {key: "status", label: "Trạng thái phát", _style: "width:10%"},
            {key: "active", label: "Trạng thái kích hoạt", _style: "width:15%"},
            {key: "action", label: "Thao tác", _style: "width:7%"}
          ],
          slots: [
            "checkbox",
            "index",
            "playDate",
            "startTime",
            "endTime",
            "active",
            "status",
            "action"
          ],
          lazyLoad: false
        },
        dataSource: {
          url: "/schedule-detail/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDate(that.dateRange.start);
            params.toDate = that.$helper.formatDate(that.dateRange.end);
            params.scheduleId = that.$route.params.id;
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    reloadPage(id) {
      let that = this;
      that.$router.replace({params: {id: id}});
      that.isShowModelUpdate = false;
      that.exist.isShowModelExist = false;
      that.loadSchedule();
    },
    updateData(id, playDate, startTime, endTime) {
      let that = this;
      that.isShowModelUpdate = true;
      that.dataDetail.id = id;
      that.dataDetail.playDate.data.model = playDate;
      // let startTime_string = startTime[0] + ':' + startTime[1];
      // let startTime_string = startTime;
      that.dataDetail.startTime.data.model = startTime;
      // let endTime_string = endTime[0] + ':' + endTime[1];
      // let endTime_string = endTime;
      that.dataDetail.endTime.data.model = endTime;
    },
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listScheduleDetailSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listScheduleDetailSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listScheduleDetailSelectedId = [];
      }
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    loadSchedule: function () {
      let that = this;
      that.loading.value = true;
      this.$helper.loadDataSource({
        url: "/schedule/find-by-id",
        dataSubmit: function () {
          return {id: that.$route.params.id}
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            var startDate = new Date(response.data.data.fromDate).setHours(0, 0, 0, 0);
            var endDate = new Date(response.data.data.toDate).setHours(23, 59, 59, 999);
            that.dateRange = {
              start: startDate,
              end: endDate
            }
            that.minDate = startDate;
            that.maxDate = endDate;
            that.scheduleData.startDate = startDate;
            that.scheduleData.endDate = endDate;
            that.scheduleData.deviceInput.data.model = response.data.data.lstDevice;
            that.scheduleData.dateRangeInput.data.model = that.$helper.formatDateDDMMYYYY(startDate) + ' - ' + that.$helper.formatDateDDMMYYYY(endDate);
            that.loading.value = false;
            // that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    submitUpdate: function () {
      let that = this;
      that.loading.value = true;
      this.$helper.loadDataSource({
        url: "/schedule-detail/update",
        dataSubmit: function () {
          return {
            id: that.dataDetail.id,
            playDate: that.dataDetail.playDate.data.model,
            startTime: that.$helper.formatHHMM(that.dataDetail.startTime.data.model),
            endTime: that.$helper.formatHHMM(that.dataDetail.endTime.data.model),
          }
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            if (response.data.data.id) {
              // that.showErrorMsg({message: that.$helper.getStringError(response.data.data.msg)});
              // that.$helper.setupErrorModel(response.data.data.msg, that.$data);
              that.exist.id = response.data.data.id;
              that.exist.msg = response.data.data.msg;
              that.exist.startTime = response.data.data.startTime;
              that.exist.endTime = response.data.data.endTime;
              that.exist.playDate = response.data.data.playDate;
              that.exist.devices = response.data.data.devices;
              that.exist.isShowModelExist = true;
            } else {
              that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
              that.$helper.setupErrorModel(response.data.data, that.$data);
            }
          } else {
            that.showSuccessMsg({message: "Cập nhật lịch phát thành công"});
            that.isShowModelUpdate = false;
            that.loadDataMainTable();
          }
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    changeSelectedAllDevice(value) {
      if (value) {
        this.scheduleData.deviceInput.data.model = this.scheduleData.deviceInput.options;
      } else {
        this.scheduleData.deviceInput.data.model = '';
      }
    },
    loadDataDevices() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/find-all",
        dataSubmit: function () {
          return {
            orgId: ''
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.scheduleData.deviceInput.options = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    submitUpdateSchedule: function () {
      let that = this;
      let isValid = true;
      isValid &= that.scheduleData.deviceInput.data.validator.valid();
      if (!isValid) {
        return;
      } else {
        that.loading.value = true;
        let devices = [];
        for (let i = 0; i < that.scheduleData.deviceInput.data.model.length; i++) {
          devices.push(that.scheduleData.deviceInput.data.model[i].value);
        }
        this.$helper.loadDataSource({
          url: "/schedule/update",
          dataSubmit: function () {
            return {
              id: that.$route.params.id,
              devices: devices
            }
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              if (response.data.data.id) {
                // that.showErrorMsg({message: that.$helper.getStringError(response.data.data.msg)});
                // that.$helper.setupErrorModel(response.data.data.msg, that.$data);
                that.exist.id = response.data.data.id;
                that.exist.msg = response.data.data.msg;
                that.exist.startTime = response.data.data.startTime;
                that.exist.endTime = response.data.data.endTime;
                that.exist.playDate = response.data.data.playDate;
                var devices = [];
                devices.push(response.data.data.device);
                that.exist.devices = devices;

                that.exist.isShowModelExist = true;
              } else {
                that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
                that.$helper.setupErrorModel(response.data.data, that.$data);
              }
            } else {
              that.showSuccessMsg({message: "Cập nhật lịch phát thành công"});
              that.isShowModelUpdate = false;
              that.loadDataMainTable();
            }
            that.loading.value = false;
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      }
    },
    setupSelectOneAction: function (actionTypeKey, id, active, playDate, startTime, endTime) {
      let actionData = this.actionData.model;
      actionData.id = id || null;
      actionData.active = active;
      actionData.startTime = startTime || null;
      actionData.endTime = endTime || null;
      actionData.playDate = playDate || null;
      actionData.scheduleId = this.$route.params.id;
      actionData.fromDate = this.scheduleData.startDate;
      actionData.toDate = this.scheduleData.endDate;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
    this.loadSchedule();
    this.loadDataDevices();
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
    'scheduleData.deviceInput.data.model': function () {
      if (this.scheduleData.deviceInput.data.model.length == this.scheduleData.deviceInput.options.length) {
        this.isSelectedAllDevices = true;
      }
    },
    'scheduleData.deviceInput.options': function () {
      if (this.scheduleData.deviceInput.data.model.length == this.scheduleData.deviceInput.options.length) {
        this.isSelectedAllDevices = true;
      }
    }
    // ,'dataDetail.startTime.data.model': function(newValue){
    //     console.log(newValue)
    // }
  },
  computed: {},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.td-roles {
  max-width: 250px;
}

.vc-date {
  display: none !important;
}

</style>
